export const SUPPORTED_LOCALES = [
  // Chinese is disabled for now in the language picker.
  // { code: "zh-Hans", locale: "zh-Hans", htmlLang: "zh-Hans", label: "Chinese (Simplified)", shortLabel: "ZH" },
  { code: "en", locale: "en", htmlLang: "en", label: "English", shortLabel: "EN" },
  { code: "de", locale: "de", htmlLang: "de", label: "German", shortLabel: "DE" },
  { code: "ru", locale: "ru", htmlLang: "ru", label: "Russian", shortLabel: "RU" },
  { code: "uk", locale: "uk-UA", htmlLang: "uk", label: "Українська", shortLabel: "UA" }
];

export const SUPPORTED_LOCALE_CODES = SUPPORTED_LOCALES.map((item) => item.code);
